import {
  Button,
  Text,
  VStack,
  useColorModeValue,
  useStyleConfig,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'

interface IProps {
  title: string
  description: string
  buttonLabel: string
  onClick: () => void
}
export const EmptyAlgorithm = ({
  title,
  description,
  buttonLabel,
  onClick,
}: IProps) => {
  const t = useTranslations()
  const grayText = useColorModeValue('gray.870', 'gray.850')
  const styles = useStyleConfig('Box', { variant: 'white' })
  return (
    <VStack alignItems={'flex-start'} w={'full'}>
      <VStack
        w={'full'}
        alignItems={'center'}
        p={'16px'}
        gap={'16px'}
        rounded={'2xl'}
        __css={styles}
      >
        <Text fontWeight={600}>{t(title)}</Text>
        <Text color={grayText}>{t(description)}</Text>
        <Button
          fontWeight={500}
          variant={'solid'}
          px="22px"
          bg="black"
          color={'white'}
          onClick={onClick}
          _hover={{
            bg: grayText,
            color: 'white',
          }}
        >
          {t(buttonLabel)}
        </Button>
      </VStack>
    </VStack>
  )
}
